<template>
  <div class="retrievalMetrics" style="margin-top: 2%;">
    <el-row justify="center" type="flex">
      <el-col  :span="10" >
        <el-table v-loading="pieLoading" 
           v-for="item in tableData.data.list" :key="item.dataStore" :data="item.metrics">
          <el-table-column prop="name" label="DataStore"  align="left"></el-table-column>
          <el-table-column prop="value" :label="item.dataStore"  align="left"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "retrievalMetrics",
        data(){
          return {
            pieLoading:false,
            tableData:{
              data:{
                list:[{
                  dataStore:'Hadoop',
                  metrics:[{
                    name: "Total Retrieval",
                    value: 1955
                  },{
                    name: "Total Retrieval Events",
                    value: 594185
                  },{
                    name: "Average Retrieval Time(ms)",
                    value: 12.744757033248082
                  },{
                    name: "Max Retrieval Time(ms)",
                    value: 382
                  },{
                    name: "Min Retrieval Time(ms)",
                    value: 2
                  },{
                    name: "Average Event Retrieval Velocity(events/s)",
                    value: 29786.172774479834
                  },{
                    name: "Max Event Retrieval Velocity(events/s)",
                    value: 265000
                  },{
                    name: "Min Event Retrieval Velocity(events/s)",
                    value: 7000
                  }]
                },{
                  dataStore:'ArchiverAppliance',
                  metrics:[{
                    name: "Total Retrieval",
                    value: 1955
                  },{
                    name: "Total Retrieval Events",
                    value: 594185
                  },{
                    name: "Average Retrieval Time(ms)",
                    value: 12.744757033248082
                  },{
                    name: "Max Retrieval Time(ms)",
                    value: 382
                  },{
                    name: "Min Retrieval Time(ms)",
                    value: 2
                  },{
                    name: "Average Event Retrieval Velocity(events/s)",
                    value: 29786.172774479834
                  },{
                    name: "Max Event Retrieval Velocity(events/s)",
                    value: 265000
                  },{
                    name: "Min Event Retrieval Velocity(events/s)",
                    value: 7000
                  }]
                },{
                  dataStore:'Total',
                  metrics:[{
                    name: "Total Retrieval",
                    value: 1955
                  },{
                    name: "Total Retrieval Events",
                    value: 594185
                  },{
                    name: "Average Retrieval Time(ms)",
                    value: 12.744757033248082
                  },{
                    name: "Max Retrieval Time(ms)",
                    value: 382
                  },{
                    name: "Min Retrieval Time(ms)",
                    value: 2
                  },{
                    name: "Average Event Retrieval Velocity(events/s)",
                    value: 29786.172774479834
                  },{
                    name: "Max Event Retrieval Velocity(events/s)",
                    value: 265000
                  },{
                    name: "Min Event Retrieval Velocity(events/s)",
                    value: 7000
                  }]
                }]
              }
            }
          }
        },
      mounted(){
          this.query();
      },
      methods:{
        query:function() {
          this.$axios({ 
              method:'get',
                url:'/hdars/hdars/api/hadarsMetrics'
              }).then((response) => {
            let data = response.data;
            this.tableData = data;
          })
        },
      }
    }

</script>

<style scoped>
  /deep/.el-table thead tr th{
      background: #f5f7fa;
  } 
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/retrievalMetrics.vue